import { NativeSelect } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';
import type { OrganizationFilter } from '@/lib/list-view/use-organization-filter';

type OrganizationFilterRowProps = { readonly filter: OrganizationFilter };

export function OrganizationFilterRow({ filter }: OrganizationFilterRowProps) {
  const tFilters = useTranslations('pages.admin.shell.filters');

  if (filter.options.length === 0) return null;

  return (
    <div className="flex flex-wrap items-end gap-3 border-b border-border bg-surface px-4 py-2">
      <label className="flex flex-col gap-1 text-sm text-text-tertiary">
        {tFilters('organization')}
        <div className="w-72">
          <NativeSelect
            size="sm"
            value={filter.organizationId ?? ''}
            aria-label={tFilters('organization')}
            options={[
              { value: '', label: tFilters('organization-all') },
              ...filter.options.map((option) => ({ value: option.id, label: option.name })),
            ]}
            onChange={(next) => filter.setOrganization(next === '' ? null : next)}
          />
        </div>
      </label>
    </div>
  );
}
